function cov_2c6i4dg3ll() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeFilled.tsx";
  var hash = "9f75fa9736f3e8c694504ff81db477f8cb29ee56";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9f75fa9736f3e8c694504ff81db477f8cb29ee56"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2c6i4dg3ll = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2c6i4dg3ll();
var Icon = (cov_2c6i4dg3ll().s[0]++, {
  name: 'home-filled',
  svg: "<path d=\"M22 21V9.52066C22 9.19434 21.8408 8.88855 21.5735 8.70143L12.5735 2.40143C12.2291 2.1604 11.7709 2.1604 11.4265 2.40143L2.42654 8.70143C2.15921 8.88855 2 9.19434 2 9.52066V21C2 21.5523 2.44772 22 3 22H9V14.5C9 12.8431 10.3431 11.5 12 11.5C13.6569 11.5 15 12.8431 15 14.5V22H21C21.5523 22 22 21.5523 22 21Z\" fill=\"currentColor\"/>"
});
export default Icon;